import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Link, useLocation } from 'react-router-dom';
import { Cookie } from 'lucide-react';

// Verificar consentimento antes de renderizar
const hasConsent = () => {
  try {
    return localStorage.getItem('cookie-consent') !== null;
  } catch {
    return false;
  }
};

export function CookieBanner() {
  // SSR/prerender: não injetar heading antes do H1 da landing
  if (typeof window === "undefined") {
    return null;
  }

  // Inicializar estado baseado no localStorage
  const [show, setShow] = useState(!hasConsent());
  const location = useLocation();

  useEffect(() => {
    // Verificar novamente após montagem (caso localStorage tenha mudado)
    const consent = localStorage.getItem('cookie-consent');
    
    if (consent) {
      // Já tem consentimento, esconder banner
      setShow(false);
    } else if (!show) {
      // Não tem consentimento e banner não está visível, mostrar após delay
      const timer = setTimeout(() => {
        setShow(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [show]);

  const handleAccept = () => {
    try {
      localStorage.setItem('cookie-consent', 'accepted');
      localStorage.setItem('cookie-consent-date', new Date().toISOString());
      setShow(false);
    } catch (error) {
      console.error('Error saving cookie consent:', error);
    }
  };

  const handleReject = () => {
    try {
      localStorage.setItem('cookie-consent', 'essential-only');
      localStorage.setItem('cookie-consent-date', new Date().toISOString());
      setShow(false);
    } catch (error) {
      console.error('Error saving cookie consent:', error);
    }
    
    // Aqui você pode adicionar lógica para desabilitar cookies não essenciais
    // Por exemplo, não carregar scripts de analytics
  };

  // Não renderizar nada se não deve mostrar
  if (!show) return null;

  return (
    <>
      {/* Banner */}
      <div className="fixed bottom-0 left-0 right-0 bg-background border-t shadow-lg z-50 animate-in slide-in-from-bottom duration-500">
        <div className="container mx-auto p-4 sm:p-6">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            {/* Ícone e Texto */}
            <div className="flex items-start gap-3 flex-1">
              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Cookie className="w-5 h-5 text-primary" />
              </div>
              <div className="flex-1">
                <p className="font-semibold text-sm sm:text-base mb-1">
                  Nós usamos cookies
                </p>
                <p className="text-xs sm:text-sm text-muted-foreground">
                  Usamos cookies essenciais para autenticação e funcionamento do site. 
                  Cookies funcionais melhoram sua experiência, como lembrar suas preferências de tema.{' '}
                  <Link 
                    to="/cookies" 
                    className="text-primary hover:underline font-medium"
                  >
                    Saiba mais
                  </Link>
                </p>
              </div>
            </div>

            {/* Botões */}
            <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
              <Button 
                variant="outline" 
                size="sm" 
                onClick={handleReject}
                className="w-full sm:w-auto text-xs sm:text-sm"
              >
                Apenas Essenciais
              </Button>
              <Button 
                size="sm" 
                onClick={handleAccept}
                className="w-full sm:w-auto text-xs sm:text-sm"
              >
                Aceitar Todos
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

